/** Matches backend general_calendar _get_ghl_crm_integration: active + saved API key. */
export function isGhlIntegrationActive(data) {
  if (!data || typeof data !== "object") return false;
  return Boolean(data.has_api_key) && data.integration?.status === "active";
}
